import React from "react";

function Tooltip(props) {
	if (props.content) {
		return (
			<div className={`tooltip-component ${props.display ? "" : "hidden"} ${props.otherClasses} `}>
				<span className="icon-close" onClick={() => props.closeTooltip()} />
				{props.content.iconMessage.map(({ icon, message }, index) => {
					return (
						<div key={index} className="icon-message">
							<i className={`icon ${icon}`} />
							{message}
						</div>
					);
				})}
				{props.content.message}
				{props.content.button && (
					<button onClick={() => props.closeTooltip()}>{props.content.button.text}</button>
				)}
			</div>
		);
	}

	return null;
}

export default Tooltip;
